import React, { Component, Fragment } from 'react';
import { Tooltip } from 'reactstrap';

import { Random } from "../utils";

import './IconToolTip.scss';

class IconToolTip extends Component {

    generatedId = Random.randomComponentId();


    state = {
        tooltipOpen: false
    };

    _setState = (obj, callback) => {
        if (this.mounted) {
			this.setState(obj, callback);
		}
    }
	
    componentDidMount() {
        this.mounted = true
	}	
		
	componentWillUnmount() {
        this.mounted = false
    }

    toggle = () => {
        this._setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    };

    render() {
        const { className, tooltipText, tooltipClassName, onMouseOver, onMouseLeave, ...otherProps } = this.props;
        const { tooltipOpen } = this.state;

        const classes = className ? [className, 'icon-tooltip'] : ['button-tooltip'];

        return (
            <Fragment>
                <button
                    className={classes.join(' ')}
                    id={'tooltip-' + this.generatedId}
                    onMouseEnter={onMouseOver}
                    onMouseLeave={onMouseLeave}
                    {...otherProps}
                >
                    {this.props.children}
                </button>
                <Tooltip
                    className="customtooltip"
                    innerClassName="customtooltip-menu-tool"
                    arrowClassName="arrow-menu-tool"
                    trigger="hover"
                    isOpen={tooltipOpen}
                    placement="right"
                    autohide={true}
                    target={'tooltip-' + this.generatedId}
                    toggle={this.toggle}
                >
                    {tooltipText}
                </Tooltip>
            </Fragment>
        );
    }
}

export default IconToolTip;
